<template>
  <div class="dashboard-need-help">
    <article class="dashboard-need-help__content">
      <img
        src="/images/FAQ.png"
        alt="Help"
        class="dashboard-need-help__image"
      />
      <section>
        <h2 class="dashboard-need-help__heading">Stuck? Need help?</h2>
        <p class="dashboard-need-help__body">
          <a href="https://faq.itreconomics.com/en">Click here</a>
          to go to our Resources Page
        </p>
      </section>
    </article>
  </div>
</template>

<style lang="scss" scoped>
  .dashboard-need-help {
    padding: 0 5px;

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;
      max-width: 270px;
    }

    &__image {
      object-fit: contain;
      object-position: 50% 50%;
      aspect-ratio: 1 / 1;

      width: 75%;
      min-width: 175px;
      max-width: 100%;
      height: auto;
      max-height: 150px;
      margin-bottom: 2em;
    }
    &__heading {
      text-align: center;
      font-size: 24px;
      margin: 0 0 20px 0;
    }
    &__body {
      text-align: center;
      font-size: 20px;
    }
  }
</style>
